<header class="navigation">
  <a class="logo">
    <img [src]="logoPath">
  </a>
  <div class="content">
  </div>
</header>